<div class="w-[391px] overflow-x-hidden rounded-lg bg-white">
	<form [formGroup]="theForm">
		<h4 class="my-2 font-display font-medium text-on-background-alt"> Veuillez préciser le lieu de naissance </h4>
		<div class="my-2">
			<uikit-input-form
				formControlName="placeOfBirth"
				label="numéro de commune"
				placeholder="84000"
			></uikit-input-form>
		</div>
		<div class="my-6 flex justify-end gap-3">
			<uikit-button
				type="tonal"
				[size]="'default'"
				(action)="onCancel()"
				>Abandonner</uikit-button
			>
			<uikit-button
				type="filled"
				[size]="'default'"
				(action)="continue()"
				>Continuer</uikit-button
			>
		</div>
	</form>
</div>
